module.exports = __webpack_public_path__ + "img/2.c29a8ea7.png";